import React from 'react';

/** Exercise 1 */
function BannerReportAnswer() {
    // report results should be displayed here.
    return <em>The results will go here</em>;
}

/** DO NOT MODIFY */
export function Banners() {
    return <div>
        <h1>Exercise 1 - Banner Analytics</h1>

        <p>There are 2 tables in the database "webapp" called: <strong>Banner</strong> and <strong>BannerTracking</strong>.</p>

        <p>Please create a query that returns the following:</p>
        <p>Banner Name and Banner Link fields and the sum of all impressions and the sum of all clicks between 11/18/2023 and 11/24/2023</p>

        <BannerReportAnswer />

        <h2><strong>Banner</strong> table</h2>
        <img src="/images/banner_design.png" alt="Banner Table Design" /><br />

        <h2><strong>BannerTracking</strong> table</h2>
        <img src="/images/bannertracking_design.png" alt="BannerTracking Table Design" /><br />

        <h2><strong>Banner</strong> table data</h2>
        <img src="/images/banner_data.png" alt="Banner Table Data" /><br />

        <h2><strong>BannerTracking</strong> table data</h2>
        <img src="/images/bannertracking_data.png" alt="BannerTracking Table Data" /><br />
    </div>
}
